import { useState, type FormEvent } from 'react';
import { Mail } from 'lucide-react';
import FormField from '@/shared/ui/FormField';
import { primaryButtonClass } from '@/shared/ui/formClasses';
import { forgotPasswordError } from '../model/credentials';

type ForgotPasswordFormProps = {
  submitting: boolean;
  onSubmit: (email: string) => void;
};

export default function ForgotPasswordForm({ submitting, onSubmit }: ForgotPasswordFormProps) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string>();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const found = forgotPasswordError(email);
    setError(found);
    if (!found) onSubmit(email);
  };

  return (
    <form noValidate onSubmit={handleSubmit} className="mt-8 space-y-5">
      <FormField
        id="forgot-email"
        label="Email"
        type="email"
        required
        autoComplete="email"
        placeholder="nome@azienda.it"
        value={email}
        onChange={setEmail}
        error={error}
        trailing={<Mail className="mr-2 h-3.5 w-3.5 text-placeholder" aria-hidden />}
      />
      <button type="submit" disabled={submitting} className={`${primaryButtonClass} w-full`}>
        {submitting ? 'Invio in corso…' : 'Invia link di reset'}
      </button>
    </form>
  );
}
